import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Kicker({ className, ...rest }) {
    return _jsx("p", { className: cn("fwfa-kicker", className), ...rest });
}
//# sourceMappingURL=Kicker.js.map